import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import {
  selectOwnershipType,
  selectPolicyUsage,
  useNewBusinessSelector,
} from "@covertree/new-business-redux";

import { NewPolicyRoutes } from "@routing/paths";

import { useResetNewPolicy } from "./useResetNewPolicy";

/**
 * Resets flow if browser tab is closed and re-opened.
 * Without this hook, the browser remembers the step that the user was on and renders it, but none of the redux data is persistent, leading to errors.
 *
 */

export const useResetFlowOnTabReopen = () => {
  const location = useLocation();
  const reset = useResetNewPolicy();

  const ownershipType = useNewBusinessSelector(selectOwnershipType);
  const policyUsage = useNewBusinessSelector(selectPolicyUsage);

  useEffect(() => {
    if (
      !ownershipType &&
      !policyUsage &&
      location.pathname !== NewPolicyRoutes.SELECT_PRODUCT
    ) {
      reset(NewPolicyRoutes.SELECT_PRODUCT);
    }
  }, [location.pathname, reset, ownershipType]);
};
